import { render, staticRenderFns } from "./error-page.vue?vue&type=template&id=28b6653a&scoped=true&lang=pug&"
import script from "./error-page.vue?vue&type=script&lang=js&"
export * from "./error-page.vue?vue&type=script&lang=js&"
import style0 from "./error-page.vue?vue&type=style&index=0&id=28b6653a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b6653a",
  null
  
)

export default component.exports